"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ThumbnailGeneratorProcessor", {
    enumerable: true,
    get: function() {
        return ThumbnailGeneratorProcessor;
    }
});
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _common = require("@nestjs/common");
const _NcPluginMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/helpers/NcPluginMgrv2"));
const _attachmentHelpers = require("~/helpers/attachmentHelpers");
const _imagethumbnailgenerator = require("~/modules/jobs/jobs/thumbnail-generator/generators/image-thumbnail-generator");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let ThumbnailGeneratorProcessor = class ThumbnailGeneratorProcessor {
    // private pdfGenerator = new PdfThumbnailGenerator();
    async job(job) {
        const { attachments, scope } = job.data;
        const results = [];
        const sharp = _Noco.default.sharp;
        if (!sharp) {
            this.logger.warn('Sharp not available, skipping thumbnail generation');
            return results;
        }
        for (const attachment of attachments){
            var _attachment_path;
            const thumbnail = await this.generateThumbnail(attachment, scope);
            if (!thumbnail) {
                continue;
            }
            results.push({
                path: (_attachment_path = attachment.path) != null ? _attachment_path : attachment.url,
                card_cover: thumbnail == null ? void 0 : thumbnail.card_cover,
                small: thumbnail == null ? void 0 : thumbnail.small,
                tiny: thumbnail == null ? void 0 : thumbnail.tiny
            });
        }
        return results;
    }
    async generateThumbnail(attachment, scope) {
        const sharp = _Noco.default.sharp;
        if (!sharp) {
            return null;
        }
        try {
            var _attachment_title;
            const storageAdapter = await _NcPluginMgrv2.default.storageAdapter();
            const { file, relativePath } = await this.getFileData(attachment, storageAdapter, scope);
            const mimeType = attachment.mimetype || '';
            const fileExtension = ((_attachment_title = attachment.title) == null ? void 0 : _attachment_title.toLowerCase()) || '';
            switch(true){
                case mimeType === 'application/pdf' || fileExtension.endsWith('.pdf'):
                    {
                        // if (Noco.isPdfjsInitialized && Noco.canvas)
                        //   return await this.pdfGenerator.generateThumbnails(
                        //     file,
                        //     relativePath,
                        //     storageAdapter,
                        //   );
                        return null;
                    }
                case mimeType.startsWith('image/'):
                    return await this.imageGenerator.generateThumbnails(file, relativePath, storageAdapter);
                default:
                    this.logger.warn({
                        message: `Unknown file type, skipping thumbnail generation`,
                        mimetype: mimeType,
                        filename: attachment.title
                    });
                    return null;
            }
        } catch (error) {
            var _attachment_path;
            this.logger.error({
                message: `Failed to generate thumbnails for ${(_attachment_path = attachment.path) != null ? _attachment_path : attachment.url}`,
                error: error == null ? void 0 : error.message
            });
            return null;
        }
    }
    async getFileData(attachment, storageAdapter, scope) {
        let relativePath;
        if (attachment.path) {
            relativePath = _path.default.join('nc', scope ? '' : 'uploads', attachment.path.replace(/^download[/\\]/i, ''));
        } else if (attachment.url) {
            relativePath = (0, _attachmentHelpers.getPathFromUrl)(attachment.url).replace(/^\/+/, '');
        }
        const file = await storageAdapter.fileRead(relativePath);
        const scopePath = scope ? scope : 'uploads';
        // remove everything before 'nc/${scopePath}/' (including nc/${scopePath}/) in relativePath
        relativePath = relativePath.replace(new RegExp(`^.*?nc[/\\\\]${scopePath}[/\\\\]`), '');
        if (scope) {
            relativePath = `${scopePath}/${relativePath}`;
        }
        return {
            file,
            relativePath
        };
    }
    constructor(){
        this.logger = new _common.Logger(ThumbnailGeneratorProcessor.name);
        this.imageGenerator = new _imagethumbnailgenerator.ImageThumbnailGenerator();
    }
};
